import { IValidator } from "../../../Validation/IValidator";
import { AddressModel } from "@truckdown/billing";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class AddressValidator implements IValidator {
    constructor(address: AddressModel | undefined) {
        this._address = address;
        this._validators = this.getValidators();
    }

    private _address: AddressModel | undefined;
    private _validators: IPropertyValidator[];

    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "line1",
                message: () => "Address line 1 required.",
                validator: () => !!this._address?.line1 && this._address?.line1.length > 0
            },
            {
                key: "city",
                message: () => "City required.",
                validator: () => !!this._address?.city && this._address?.city.length > 0
            },
            {
                key: "regionCode",
                message: () => "Region Code required.",
                validator: () => !!this._address?.regionCode && this._address?.regionCode.length > 0
            },
            {
                key: "postalCode",
                message: () => "Postal Code required.",
                validator: () => !!this._address?.postalCode && this._address?.postalCode.length > 0
            },
            {
                key: "postalCodeFinal",
                message: () => "Invalid Postal/Zip Code. For Canada, use the format A1A 1A1. For the USA, use 12345 or 12345-6789.",
                validator: () => this.validatePostalCode(this._address?.countryCode, this._address?.postalCode)

            },
            {
                key: "countryCode",
                message: () => "Country Code required.",
                validator: () => !!this._address?.countryCode && this._address?.countryCode.length > 0
            }
        ];
    };

    private validatePostalCode(countryCode: string | undefined, postalCode: string | undefined): boolean {
        const usRegex = /^\d{5}(?:[-\s]\d{4})?$/; // US postal code format: 12345 or 12345-6789
        const caRegex = /^[ABCEGHJKLMNPRSTVXY]\d[A-Z] \d[A-Z]\d$/i; // CA postal code format: A1A 1A1

        let regex: RegExp;

        if (countryCode?.toUpperCase() === 'US') {
            regex = usRegex;
        } else if (countryCode?.toUpperCase() === 'CA') {
            regex = caRegex;
        } else {
            return false;
        }
        return regex.test(postalCode || "");
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    reset() {
        this.errors = {};
    }

    errors: { [key: string]: string } = {};
}